import { Role } from 'src/@types/role';

const DEFAULT_HOME_ROUTE: Record<Role, string> = {
  [Role.NuminarAdmin]: '/home',
  [Role.ManagedOutreachCoordinator]: '/projects',
  [Role.Owner]: '/home',
  [Role.OrgAdmin]: '/home',
  [Role.ParentAdmin]: '/home',
  [Role.Staff]: '/home',
  [Role.FieldOrganizer]: '/projects',
  [Role.Volunteer]: '/projects',
  [Role.Supporter]: '/projects',
  [Role.DTAdmin]: '/lists',
  [Role.DatatrustOwner]: '/lists',
  [Role.DatatrustUser]: '/lists',
};

const defaultHandler: ProxyHandler<Record<Role, string>> = {
  get: (target, prop: keyof typeof target) => (prop in target ? target[prop] : '/home'),
};

const DefaultHomeRoute = new Proxy(DEFAULT_HOME_ROUTE, defaultHandler);

export default DefaultHomeRoute;
